import { makeStyles } from '@material-ui/core';
import { calculateWidth, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  cancelButton: {
    fontSize: vh(2.08),
    border: `solid 1px ${themeColor.secondaryLight}`,
    color: themeColor.almostblack,
  },
  approveButton: {
    marginLeft: calculateWidth(10).stringValue,
    fontSize: vh(2.08),
    border: `1px solid ${themeColor.secondaryLight}`,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '&:disabled': {
      color: themeColor.rollingStone,
      background: themeColor.progressBar,
      opacity: '1',
      '& span': {
        opacity: 1,
      },
    },
  },
}));
